import { render } from "./AlterModal.vue?vue&type=template&id=2700a118&scoped=true"
import script from "./AlterModal.vue?vue&type=script&lang=js"
export * from "./AlterModal.vue?vue&type=script&lang=js"

import "./AlterModal.vue?vue&type=style&index=0&id=2700a118&lang=scss&scoped=true"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2700a118"],['__file',"src/components/irrigation/AlterModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2700a118"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2700a118', __exports__)) {
    console.log('reload')
    api.reload('2700a118', __exports__)
  }
  
  module.hot.accept("./AlterModal.vue?vue&type=template&id=2700a118&scoped=true", () => {
    console.log('re-render')
    api.rerender('2700a118', render)
  })

}


export default __exports__